<template>
	<div>
		<component-modalfollowers :iduser="userdataprofile._id" :ismyprofile="ismyprofile"/>
		<v-layout justify-center>
            <v-dialog v-model="modaldescription" persistent max-width="290">
                <v-card>
                    <v-card-title class="headline">{{nameproject}}</v-card-title>
                    <v-card-text>{{descriptionproject}}</v-card-text>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="modaldescription = false">{{language==='English'?'Close':'Cerrar'}}</v-btn>                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
		<v-layout v-if="ismyprofile">
			<v-dialog v-model="modaledituser" max-width="600" max-height="98%" persistent>
				<button type="button" class="close" @click="modaledituser = false">
					<span style="color:black;font-size:30px" aria-hidden="true">&times;</span>
				</button>
				<v-container style="background:white" grid-list-xs text-xs-center >
					<v-layout v-if="!isitemexperiencemodal" justify-center> 
						<h2 class="font-weight-bold" >{{language === 'English' ? 'Edit Profile' : 'Editar Perfil'}}</h2>
					</v-layout>
					<v-layout v-if="isitemexperiencemodal" justify-center> 
						<h2 class="font-weight-bold" >{{language === 'English' ? !isedit?'Add your Work Experiences':'Edit your Work Experience' :!isedit?'Agrega tus Experiencias Laborales':'Edita tu Experiencia Laboral'}}</h2>
					</v-layout>
					<form @submit.prevent="createexperience" v-if="isitemexperiencemodal" style="margin-top:20px">
						<v-layout row >
							<v-flex>
								<div style="margin-bottom:20px">
									<input class="form-control" :placeholder="language === 'English'?'job position':'Puesto'" required v-model="modelexperiences.name"/>
								</div>
								<div style="margin-bottom:20px">
									<input class="form-control" :placeholder="language === 'English'?'Company':'Empresa'" required v-model="modelexperiences.name_company"/>
								</div>
								<div style="margin-bottom:20px">
									<textarea class="form-control" :placeholder="language === 'English'?'Job Description':'Descripción del Puesto'" required  v-model="modelexperiences.description">
									</textarea>  
								</div>
								<v-layout justify-center >                        
									<v-btn  type="submit" depressed round color="#007bff" style="border:2px solid;border-radius: 10px 10px 10px 10px;width:90%;color:white">{{language === 'English'?!isedit?'CREATE WORK EXPERIENCE':'EDIT WORK EXPERIENCE':!isedit?'CREAR EXPERIENCIA':'EDITAR EXPERIENCIA'}}</v-btn>                       
								</v-layout>
								<v-layout justify-center >                        
									<v-btn @click="modaledituser = false" depressed round color="secondary" style="color:white;border:2px solid;border-radius: 10px 10px 10px 10px;width:90%">{{language === 'English'?'CLOSE':'CERRAR'}}</v-btn>                        
								</v-layout>
							</v-flex>
						</v-layout>
					</form>
					<v-form v-if="!isitemexperiencemodal" ref="form" v-model="valid" lazy-validation @submit.prevent="validate()">
							<v-layout row >
								<v-flex>
									<div class="form-group col-md-12">
										<img style="cursor:pointer" @click="upload()" class="perfil" id="avatar" :src="imageUrl" data-toggle="tooltip" :title="language ==='English'?'Click to upload your photo':'Hague click para subir su foto'">
										<v-layout>
											<div class="JImg-opciones JImg-opciones--close" v-if="imageFile!=''" @click="removeImage();iseditimage = false">
												<a  href="javascript:void(0)"><i class="fas fa-times"></i></a>
											</div>
											<div class="JImg-opciones JImg-opciones--close" v-if="imageFile!=''" @click="saveimage();iseditimage = true">
												<a  href="javascript:void(0)"><i class="fas fa-check"></i></a>
											</div>
										</v-layout>
										<input
												type="file"
												style="display: none"
												ref="image"
												accept="image/*"
												@change="onFilePicked"
										> 
									</div>
									<v-text-field @keyup="writefullname" :label="language === 'English'?'Names and Surnames':'Nombres y Apellidos'" v-model="users.fullname" :rules="[rules.required]" required>
									</v-text-field>  
									<div class="form-check form-check-inline">
										<input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="M" v-model="users.gender">
										<label class="form-check-label" for="inlineRadio1">{{language === 'English' ? 'Male' : 'Masculino'}}</label>
									</div>
									<div class="form-check form-check-inline">
										<input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="F" v-model="users.gender">
										<label class="form-check-label" for="inlineRadio2">{{language === 'English' ? 'Female' : 'Femenino'}}</label>
									</div>                                         
										<v-layout>
											<v-flex > 
												<v-text-field @keyup="writephone" :label="language === 'English' ? 'Telephone or cell phone number':'Numero de telefono o celular'" v-model="users.phone"  type="number">
												</v-text-field>
											</v-flex>
										</v-layout>
										<label @click="addocupation" style="cursor:pointer">{{language === 'English' ? 'Add more occupations':'Agregar mas ocupaciones'}}</label>
										<div class="scrollmenucompany" style="overflow-y: scroll;height:200px;">
											<v-layout v-for="(ocupation,index) in users.ocupation" :key="ocupation.length" style="width:100%">
												<v-flex>
													<v-text-field :append-icon="index >0 ? 'fa-trash':''" @click:append="ocupation._id ===undefined ? deleteocupation(ocupation.id):deleteocupation(ocupation._id)"
													:label="language === 'English'?'occupation '+ parseInt(index+1):'ocupación '+ parseInt(index+1)" v-model="ocupation.name" :rules="[rules.required]" required>
													</v-text-field>
												</v-flex>
											</v-layout>
										</div>
									<div class="row" style="margin-left:3px">
										<div class="form-check">
											<input v-model="emailedit" @click="usernameedit = false" type="checkbox" class="form-check-input">
											<label class="form-check-label" for="exampleCheck1">{{language === 'English'?'Edit Email':'Editar Email'}}</label>
										</div>
									</div>
									<v-layout v-if="emailedit">
										<v-flex> 
											<v-text-field label="Email" @keyup="writeemail" v-model="users.email" :rules="[rules.required, rules.emailvalidate]" required id="email">
											</v-text-field>
											<v-layout v-if="emailExist">
												<label class ="fas fa-exclamation-triangle"> {{language === 'English'?'there is a user with this email': 'Existe un Usuario con este email'}}</label>
											</v-layout>    
										</v-flex>
									</v-layout>
									<div class="row" style="margin-left:3px">
										<div class="form-check">
											<input v-model="usernameedit" @click="emailedit=false" type="checkbox" class="form-check-input">
											<label class="form-check-label" for="exampleCheck1">{{language === 'English'?'Edit Username':'Editar Nombre de Usuario'}}</label>
										</div>
									</div>
									<v-layout v-if="usernameedit">
										<v-flex > 
											<v-text-field @keyup="writeusername" :label="language === 'English'?'Username':'Nombre de usuario'" v-model="users.username" :rules="[rules.required]" required
											></v-text-field>
											<v-layout v-if="userNameExist">
												<label class ="fas fa-exclamation-triangle"> {{language === 'English' ? 'username is not available': 'El nombre de usuario no esta disponible'}}</label>
											</v-layout>
										</v-flex>
									</v-layout>
									<div class="row" style="margin-left:3px">
										<div class="form-check">
											<input v-model="passwordempty" type="checkbox" class="form-check-input">
											<label class="form-check-label" for="exampleCheck1">{{language === 'English'?'Edit Password':'Editar Contraseña'}}</label>
										</div>
									</div>
									<v-layout v-if="passwordempty">
										<v-flex > 
											<v-text-field 
												:append-icon="InputPassword ? 'fa-eye-slash' : 'fa-eye'"
												:rules="[rules.required, rules.min]"
												:type="InputPassword ? 'text' : 'password'"
												name="input-10-2"
												v-model="passwordmodel"
												:label="language === 'English'?'Password':'Contraseña'"                              
												value=""
												class="input-group--focused"
												@click:append="InputPassword = !InputPassword"
												required                    
											></v-text-field>
										</v-flex>
									</v-layout>
									<v-layout v-if="passwordempty">
										<v-flex > 
											<v-text-field :append-icon="ConfirmPassword ? 'fa-eye-slash' : 'fa-eye'" 
												:rules="[rules.required, rules.passwordequal]" 
												:type="ConfirmPassword ? 'text' : 'password'" name="input-10-2" :label="language === 'English'?'Confirm Password':'Confirmar Contraseña'" value="" 
												class="input-group--focused" @click:append="ConfirmPassword = !ConfirmPassword" required >
											</v-text-field>
										</v-flex>
									</v-layout>
									<v-layout justify-center v-if="iconloadingforeditdata"> 
										<v-progress-circular
										indeterminate
										color="primary"
										></v-progress-circular>
									</v-layout>
									<v-layout justify-center v-if="!iconloadingforeditdata">                        
										<v-btn :disabled="!valid" type="submit" depressed round color="#007bff" style="border:2px solid;border-radius: 10px 10px 10px 10px;width:90%;color:white">{{language === 'English'?'EDIT':'EDITAR'}}</v-btn>                       
									</v-layout>
									<v-layout justify-center >                        
										<v-btn @click="modaledituser = false" depressed round color="secondary" style="color:white;border:2px solid;border-radius: 10px 10px 10px 10px;width:90%">{{language === 'English'?'CLOSE':'CERRAR'}}</v-btn>                        
									</v-layout>

								</v-flex>
							</v-layout>
						</v-form>
				</v-container>
			</v-dialog>
		</v-layout>
		<header>
		<div class="container" style="margin-top:20px">
			<div class="heading-wrapper">
				<div class="row justify-center">
					<div class="col-sm-6 col-md-6 col-lg-4">
						<div class="info">
							<i class="icon fas fa-user"></i>
							<div class="right-area" style="cursor:pointer" @click="openmodalfollowers">
								<h5 style="color:white;font-weight:bold">{{countfollowers}}</h5>
								<h5 style="color:white;font-weight:bold" v-if="countfollowers === 1">{{language==='English'?'Follower':'Seguidor'}}</h5>
								<h5 style="color:white;font-weight:bold" v-else>{{language==='English'?'Followers':'Seguidores'}}</h5>
							</div><!-- right-area -->
						</div><!-- info -->
					</div><!-- col-sm-4 -->
					
					<div class="col-sm-6 col-md-6 col-lg-4">
						<div class="info">
							<i class="icon fas fa-tools"></i>
							<div class="right-area">
								<h5 v-if="numberprojects >=0" style="color:white;font-weight:bold">{{abbreviateNumber}}</h5>
								<h5 style="color:white;font-weight:bold">{{numberprojects === 1?language === 'English' ? 'Project' : 'Proyecto':language === 'English' ? 'Projects' : 'Proyectos'}}</h5>
							</div><!-- right-area -->
						</div><!-- info -->
					</div><!-- col-sm-4 -->
				</div><!-- row -->
			</div><!-- heading-wrapper -->
			<v-menu v-if="ismyprofile && !photocoverconfirm">
				<v-btn class="mx-2" slot="activator"  fab dark color="#007bff">
					<v-icon dark>fas fa-wrench</v-icon>
				</v-btn>
				<v-list>
					<v-list-tile @click="openedituser">
                        <label>{{language==='English'?'Edit Profile':'Editar Perfil'}}</label>
                    </v-list-tile>
					<v-list-tile @click="uploadphotocover">
                        <label>{{language==='English'?'upload cover photo':'Subir Foto de Portada'}}</label>
                    </v-list-tile>
					<v-list-tile @click="addworkexperience">
                        <label>{{language==='English'?'Add Work Experience':'Agregar Experiencia Laboral'}}</label>
                    </v-list-tile>
					<v-list-tile @click="gotoprojects">
                        <label>{{language === 'English' ? 'Create Project' : 'Crear Proyecto'}}</label>
                    </v-list-tile>
				</v-list>
			</v-menu>
			<v-menu>
				<v-btn class="mx-2" slot="activator"  fab dark color="#007bff">
						<v-icon dark>fas fa-share-alt</v-icon>
				</v-btn>
					<social-sharing :url="url" 
						:title="title"
						:description="description"
						:quote="quote"
						inline-template>
						<v-list>
							<v-list-tile>
								<network network="facebook" style="background:white;">
									<label class="fab fa-facebook" style="font-size:20px;background:white;width:100%"> Facebook</label> 
								</network>
							</v-list-tile>
							<v-list-tile style="margin-top:10px">
								<br/>
								<network network="twitter" style="background:white;">
										<label class="fab fa-twitter" style="font-size:20px;background:white;"> Twitter</label> 
								</network>
							</v-list-tile>
							<v-list-tile style="margin-top:10px">
								<br/>
								<network network="reddit" style="background:white">
										<label class="fab fa-reddit" style="font-size:20px;background:white"> Reddit</label> 
								</network>
							</v-list-tile>
							<v-list-tile style="margin-top:10px">
								<br/>
								<network network="googleplus" style="background:white">
										<label class="fab fa-google" style="font-size:20px;background:white"> Google</label> 
								</network>
							</v-list-tile>
							<v-list-tile style="margin-top:10px">
								<br/>
								<network network="whatsapp" style="background:white">
										<label class="fab fa-whatsapp" style="font-size:20px;background:white"> Whatsapp</label> 
								</network>
							</v-list-tile>
							<v-list-tile style="margin-top:10px">
								<br/>
								<network network="linkedin" style="background:white">
										<label class="fab fa-linkedin" style="font-size:20px;background:white"> Linkedin</label> 
								</network>
							</v-list-tile>
							<v-list-tile style="margin-top:10px">
								<br/>
								<network network="email" style="background:white">
										<label class="fas fa-envelope" style="font-size:20px;background:white"> Email</label> 
								</network>
							</v-list-tile>
							<v-list-tile style="margin-top:10px">
								<br/>
								<network network="telegram" style="background:white">
										<label class="fab fa-telegram" style="font-size:20px;background:white"> Telegram</label> 
								</network>
							</v-list-tile>
							<v-list-tile style="margin-top:10px">
								<br/>
								<network network="line" style="background:white">
										<label class="fab fa-line" style="font-size:20px;background:white"> Line</label> 
								</network>
							</v-list-tile>
							<v-list-tile style="margin-top:10px">
								<br/>
								<network network="pinterest" style="background:white">
										<label class="fab fa-pinterest" style="font-size:20px;background:white"> Pinterest</label> 
								</network>
							</v-list-tile>
							<v-list-tile style="margin-top:10px">
								<br/>
								<network network="sms" style="background:white">
										<label class="fas fa-comment" style="font-size:20px;background:white"> SMS</label> 
								</network>
							</v-list-tile>
							<v-list-tile style="margin-top:10px">
								<br/>
								<network network="skype" style="background:white">
										<label class="fab fa-skype" style="font-size:20px;background:white"> Skype</label> 
								</network>
							</v-list-tile>
						</v-list>	
					</social-sharing>			
			</v-menu>
			<input
					type="file"
					style="display: none"
					ref="imagecover"
					accept="image/*"
					@change="onFilePickedphotocover"
			> 
			<div v-if="session">
				<v-btn :loading="loadingphotocover"
      			:disabled="loadingphotocover"  class="mx-2" slot="activator"  fab dark color="#007bff" v-if="ismyprofile && photocoverconfirm" @click="uploadimage">
					<v-icon dark>fas fa-check</v-icon>
				</v-btn>
				<v-btn :disabled="loadingphotocover" @click="nouploadimage" class="mx-2" slot="activator"  fab dark color="#007bff" v-if="ismyprofile && photocoverconfirm">
					<v-icon dark>fas fa-times</v-icon>
				</v-btn>
				<v-btn
					color="#007bff"
					class="ma-2 white--text"
					@click="sendtohichat"
					v-if="!ismyprofile && session"
				>
					{{language==='English'?'Message':'Mensaje'}}
					<v-icon right dark>fas fa-comment</v-icon>
				</v-btn>
				<v-btn
					color="#007bff"
					class="ma-2 white--text"
					@click="sendWhatsapp"
					v-if="!ismyprofile && userdataprofile.phone"
				>
					{{language==='English'?'Whatsapp':'Whatsapp'}}
					<v-icon right dark>fab fa-whatsapp</v-icon>
				</v-btn>
				<v-btn
					color="#007bff"
					class="ma-2 white--text"
					@click="goTocall"
					v-if="!ismyprofile && userdataprofile.phone"
				>
					{{language==='English'?'Call':'Llamar'}}
					<v-icon right dark>fas fa-phone</v-icon>
				</v-btn>
				<button class="btn btn-primary" style="color:white;margin-top:10px" @click="followthisuser" v-if="ismyprofile ===false && userisfollowing === false">{{language === 'English' ? 'Follow' : 'Seguir'}}</button>
				<button class="btn btn-primary" style="color:white;margin-top:10px" @click="stopfollowinguser" v-if="ismyprofile ===false && userisfollowing === true">{{language === 'English' ? 'Stop following' : 'Dejar de Seguir'}}</button>
			</div>


		</div><!-- container -->
	</header>
	
	<section class="intro-section" :style="'background-image: url('+coverimageUrl+'); margin-top:40px'">
		<div class="container">
			<div class="row">
				<div class="col-md-1 col-lg-2"></div>
				<div class="col-md-10 col-lg-8">
					<div class="intro">
						<div class="profile-img"><img :src="userdataprofile.photo[0].link"></div>
						<h2><b>{{userdataprofile.fullname}}</b></h2>
						<h4 class="font-yellow">{{ocupation}}</h4>
						<ul class="information margin-tb-30">
							<li><b>EMAIL : </b>{{userdataprofile.email}}</li>
						</ul>
						<!--ul class="social-icons">
							<li><a href="#"><i class="ion-social-pinterest"></i></a></li>
							<li><a href="#"><i class="ion-social-linkedin"></i></a></li>
							<li><a href="#"><i class="ion-social-instagram"></i></a></li>
							<li><a href="#"><i class="ion-social-facebook"></i></a></li>
							<li><a href="#"><i class="ion-social-twitter"></i></a></li>
						</ul-->
					</div><!-- intro -->
				</div><!-- col-sm-8 -->
			</div><!-- row -->
		</div><!-- container -->
	</section><!-- intro-section -->
	
	<section class="portfolio-section section" style="margin-bottom:20px">
		<div class="container">
			<div class="row">
				<div class="col-sm-4">
					<div class="heading">
						<h3><b>{{language==='English'?'Projects':'Proyectos'}}</b></h3>
					</div>
				</div><!-- col-sm-4 -->
				<div class="col-sm-8">
					<div class="portfolioFilter clearfix margin-b-80">
						<a v-for="typeproject in typeproject" class="current" :key="typeproject.length" @click="typeprojectchoosed = typeproject.value; getprojectsvisiblepublic()"><b>{{typeproject.name}}</b></a>
					</div><!-- portfolioFilter -->
				</div><!-- col-sm-8 -->
			</div><!-- row -->
		</div><!-- container -->
		<div class="text-center" v-if="dataprojectsvisiblepublic.length<=0">
			<label>{{language==='English'?'No data':'No hay datos'}}</label>
		</div>
		<div class="portfolioContainer" v-else>
			<v-layout justify-center style="margin-top:20px;">
                <v-flex row lg9 xl8>
                    <v-card style="margin-top:20px"
                        v-for="(item, index) in dataprojectsvisiblepublic"
                        :key="index"
                        class="mx-auto"
                        max-width="300"
                    >
                        <v-img
                        :src="item.type==='Proyectos Electrónicos'?'/img/board-453758_640.jpg':
                        item.type==='Portafolio'?'/img/briefcase-161032_640.png':
                        item.type==='Ingenieria'?'/img/planning-3536758_640.jpg':
                        item.type==='General'?'/img/idea-1876659_640.jpg':''"
                        width="300px"
                        height="200px"
                        ></v-img>

                        <v-card-title>
                        {{item.name}}
                        </v-card-title>
						<div class="text-center" v-if="session && !ismyprofile">
							<div class="ec-stars-wrapper">
								<label>Vote</label>
								<a data-value="1" :title="language==='English'?'Vote with 1 star':'Votar con 1 estrella'" @click="votingforproject(1,item._id)">&#9733;</a>
								<a data-value="2" :title="language==='English'?'Vote with 2 stars':'Votar con 2 estrellas'" @click="votingforproject(2,item._id)">&#9733;</a>
								<a data-value="3" :title="language==='English'?'Vote with 3 stars':'Votar con 3 estrellas'" @click="votingforproject(3,item._id)">&#9733;</a>
								<a data-value="4" :title="language==='English'?'Vote with 4 stars':'Votar con 4 estrellas'" @click="votingforproject(4,item._id)">&#9733;</a>
								<a data-value="5" :title="language==='English'?'Vote with 5 stars':'Votar con 5 estrellas'" @click="votingforproject(5,item._id)">&#9733;</a>
							</div>
						</div>
						<div class="text-left" style="margin-left:10px" v-if="false">
                            <label style="font-size:15px;font-weight:bold">$200</label>
                        </div>
						<div class="text-right" style="margin-right:20px">
							<label v-if="item.punctuation === 1">{{item.punctuation}} <i class="fas fa-star"></i></label>
							<label v-else>{{item.punctuation}} <i class="fas fa-star"></i></label>
						</div>


                        <v-card-actions>
                        <v-btn icon @click="checkfileproject(item._id)">
								<v-icon>fas fa-eye</v-icon>
							</v-btn>
                        <v-btn icon @click="gocomments(item._id)">
                            <v-icon>fas fa-comments</v-icon>
                            <!--span class="campana">15k</span-->
                        </v-btn>
						<v-btn  icon @click="goprofile(item._id_user)" v-if="false">
                            <v-icon>fas fa-cart-plus</v-icon>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                            
                            @click="showdescription(item.name,item.description)"
                        >{{language==='English'?'See more':'Ver mas'}}

                        </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-flex>
            </v-layout>
			
		
		</div><!-- portfolioContainer -->
		
	</section><!-- portfolio-section -->
	
	<section class="education-section section" v-if="dataexperiences.length >0">
		<div class="container">
			<div class="row">
				<div class="col-sm-4">
					<div class="heading">
						<h4><p style="color:#007bff; font-weight:bold">{{language==='English'?'Work Experiences':'Experiencias Laborales'}}</p></h4>
					</div>
				</div><!-- col-sm-4 -->
				<div class="col-sm-8">
					<div class="education-wrapper">
						<div class="education margin-b-50" v-for="dataexperiences in dataexperiences" :key="dataexperiences.key">
							<h4><b>{{dataexperiences.name}}</b></h4>
							<h5 class="font-yellow"><b>{{language==='English'?'Company ':'Empresa '}}{{dataexperiences.name_company}}</b></h5>
							<!--h6 class="font-lite-black margin-t-10">GRADUATED IN MAY 2010(2 YEARS)</h6-->
							<p class="margin-tb-30">{{dataexperiences.description}}</p>
							<v-btn v-if="ismyprofile" icon @click="getdataexperienceforedit(dataexperiences)">
										<v-icon>fas fa-edit</v-icon>
									</v-btn>
									<v-btn v-if="ismyprofile" icon @click="deleteexperience(dataexperiences._id)">
										<v-icon>fas fa-trash</v-icon>
									</v-btn>
						</div><!-- education -->
						
						
					</div><!-- education-wrapper -->
				</div><!-- col-sm-8 -->
			</div><!-- row -->
		</div><!-- container -->
		
	</section><!-- about-section -->
	
	
	
		
		<!--component-modalfollowers :iduser="userdataprofile._id" :ismyprofile="ismyprofile"/>
		<div v-if="!userdataprofile" class="text-center w-100" style="margin-top:100px">
			<label>{{language === 'English' ? 'no data' : 'No hay datos'}}</label>
		</div>
		<div v-else>
			<component-errorpage v-if="errorpage"/>
			<div v-else style="padding-top:3%;margin-bottom:20px">
				<v-layout v-if="ismyprofile">
					<v-dialog v-model="modaledituser" max-width="600" max-height="98%" persistent>
						<button type="button" class="close" @click="modaledituser = false">
							<span style="color:black;font-size:30px" aria-hidden="true">&times;</span>
						</button>
						<v-container style="background:white" grid-list-xs text-xs-center >
							<v-layout v-if="!isitemexperiencemodal" justify-center> 
								<h2 class="font-weight-bold" >{{language === 'English' ? 'Edit Profile' : 'Editar Perfil'}}</h2>
							</v-layout>
							<v-layout v-if="isitemexperiencemodal" justify-center> 
								<h2 class="font-weight-bold" >{{language === 'English' ? !isedit?'Add your Work Experiences':'Edit your Work Experience' :!isedit?'Agrega tus Experiencias Laborales':'Edita tu Experiencia Laboral'}}</h2>
							</v-layout>
							<form @submit.prevent="createexperience" v-if="isitemexperiencemodal">
								<v-layout row >
									<v-flex>
										<div style="margin-bottom:20px">
											<input class="form-control" :placeholder="language === 'English'?'job position':'Puesto'" required v-model="modelexperiences.name"/>
										</div>
										<div style="margin-bottom:20px">
											<input class="form-control" :placeholder="language === 'English'?'Company':'Empresa'" required v-model="modelexperiences.name_company"/>
										</div>
										<div style="margin-bottom:20px">
											<textarea class="form-control" :placeholder="language === 'English'?'Job Description':'Descripción del Puesto'" required  v-model="modelexperiences.description">
											</textarea>  
										</div>
										<v-layout justify-center >                        
											<v-btn  type="submit" depressed round color="#007bff" style="border:2px solid;border-radius: 10px 10px 10px 10px;width:90%;color:white">{{language === 'English'?!isedit?'CREATE WORK EXPERIENCE':'EDIT WORK EXPERIENCE':!isedit?'CREAR EXPERIENCIA':'EDITAR EXPERIENCIA'}}</v-btn>                       
										</v-layout>
										<v-layout justify-center >                        
											<v-btn @click="modaledituser = false" depressed round color="secondary" style="color:white;border:2px solid;border-radius: 10px 10px 10px 10px;width:90%">{{language === 'English'?'CLOSE':'CERRAR'}}</v-btn>                        
										</v-layout>
									</v-flex>
								</v-layout>
							</form>
							<v-form v-if="!isitemexperiencemodal" ref="form" v-model="valid" lazy-validation @submit.prevent="validate()">
									<v-layout row >
										<v-flex>
											<div class="form-group col-md-12">
												<img style="cursor:pointer" @click="upload()" class="perfil" id="avatar" :src="imageUrl" data-toggle="tooltip" :title="language ==='English'?'Click to upload your photo':'Hague click para subir su foto'">
												<v-layout>
													<div class="JImg-opciones JImg-opciones--close" v-if="imageFile!=''" @click="removeImage();iseditimage = false">
														<a  href="javascript:void(0)"><i class="fas fa-times"></i></a>
													</div>
													<div class="JImg-opciones JImg-opciones--close" v-if="imageFile!=''" @click="saveimage();iseditimage = true">
														<a  href="javascript:void(0)"><i class="fas fa-check"></i></a>
													</div>
												</v-layout>
												<input
														type="file"
														style="display: none"
														ref="image"
														accept="image/*"
														@change="onFilePicked"
												> 
											</div>
											<v-text-field @keyup="writefullname" :label="language === 'English'?'Names and Surnames':'Nombres y Apellidos'" v-model="users.fullname" :rules="[rules.required]" required>
											</v-text-field>  
											<div class="form-check form-check-inline">
												<input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="M" v-model="users.gender">
												<label class="form-check-label" for="inlineRadio1">{{language === 'English' ? 'Male' : 'Masculino'}}</label>
											</div>
											<div class="form-check form-check-inline">
												<input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="F" v-model="users.gender">
												<label class="form-check-label" for="inlineRadio2">{{language === 'English' ? 'Female' : 'Femenino'}}</label>
											</div>                                         
												<v-layout>
													<v-flex > 
														<v-text-field @keyup="writephone" :label="language === 'English' ? 'Telephone or cell phone number':'Numero de telefono o celular'" v-model="users.phone" :rules="[rules.required]" required type="number">
														</v-text-field>
													</v-flex>
												</v-layout>
												<label @click="addocupation" style="cursor:pointer">{{language === 'English' ? 'Add more occupations':'Agregar mas ocupaciones'}}</label>
												<div class="scrollmenucompany" style="overflow-y: scroll;height:200px;">
													<v-layout v-for="(ocupation,index) in users.ocupation" :key="ocupation.length" style="width:100%">
														<v-flex>
															<v-text-field :append-icon="index >0 ? 'fa-trash':''" @click:append="ocupation._id ===undefined ? deleteocupation(ocupation.id):deleteocupation(ocupation._id)"
															:label="language === 'English'?'occupation '+ parseInt(index+1):'ocupación '+ parseInt(index+1)" v-model="ocupation.name" :rules="[rules.required]" required>
															</v-text-field>
														</v-flex>
													</v-layout>
												</div>
											<div class="row" style="margin-left:3px">
												<div class="form-check">
													<input v-model="emailedit" @click="usernameedit = false" type="checkbox" class="form-check-input">
													<label class="form-check-label" for="exampleCheck1">{{language === 'English'?'Edit Email':'Editar Email'}}</label>
												</div>
											</div>
											<v-layout v-if="emailedit">
												<v-flex> 
													<v-text-field label="Email" @keyup="writeemail" v-model="users.email" :rules="[rules.required, rules.emailvalidate]" required id="email">
													</v-text-field>
													<v-layout v-if="emailExist">
														<label class ="fas fa-exclamation-triangle"> {{language === 'English'?'there is a user with this email': 'Existe un Usuario con este email'}}</label>
													</v-layout>    
												</v-flex>
											</v-layout>
											<div class="row" style="margin-left:3px">
												<div class="form-check">
													<input v-model="usernameedit" @click="emailedit=false" type="checkbox" class="form-check-input">
													<label class="form-check-label" for="exampleCheck1">{{language === 'English'?'Edit Username':'Editar Nombre de Usuario'}}</label>
												</div>
											</div>
											<v-layout v-if="usernameedit">
												<v-flex > 
													<v-text-field @keyup="writeusername" :label="language === 'English'?'Username':'Nombre de usuario'" v-model="users.username" :rules="[rules.required]" required
													></v-text-field>
													<v-layout v-if="userNameExist">
														<label class ="fas fa-exclamation-triangle"> {{language === 'English' ? 'username is not available': 'El nombre de usuario no esta disponible'}}</label>
													</v-layout>
												</v-flex>
											</v-layout>
											<div class="row" style="margin-left:3px">
												<div class="form-check">
													<input v-model="passwordempty" type="checkbox" class="form-check-input">
													<label class="form-check-label" for="exampleCheck1">{{language === 'English'?'Edit Password':'Editar Contraseña'}}</label>
												</div>
											</div>
											<v-layout v-if="passwordempty">
												<v-flex > 
													<v-text-field 
														:append-icon="InputPassword ? 'fa-eye-slash' : 'fa-eye'"
														:rules="[rules.required, rules.min]"
														:type="InputPassword ? 'text' : 'password'"
														name="input-10-2"
														v-model="passwordmodel"
														:label="language === 'English'?'Password':'Contraseña'"                              
														value=""
														class="input-group--focused"
														@click:append="InputPassword = !InputPassword"
														required                    
													></v-text-field>
												</v-flex>
											</v-layout>
											<v-layout v-if="passwordempty">
												<v-flex > 
													<v-text-field :append-icon="ConfirmPassword ? 'fa-eye-slash' : 'fa-eye'" 
														:rules="[rules.required, rules.passwordequal]" 
														:type="ConfirmPassword ? 'text' : 'password'" name="input-10-2" :label="language === 'English'?'Confirm Password':'Confirmar Contraseña'" value="" 
														class="input-group--focused" @click:append="ConfirmPassword = !ConfirmPassword" required >
													</v-text-field>
												</v-flex>
											</v-layout>
											<v-layout justify-center v-if="iconloadingforeditdata"> 
												<v-progress-circular
												indeterminate
												color="primary"
												></v-progress-circular>
											</v-layout>
											<v-layout justify-center v-if="!iconloadingforeditdata">                        
												<v-btn :disabled="!valid" type="submit" depressed round color="#007bff" style="border:2px solid;border-radius: 10px 10px 10px 10px;width:90%;color:white">{{language === 'English'?'EDIT':'EDITAR'}}</v-btn>                       
											</v-layout>
											<v-layout justify-center >                        
												<v-btn @click="modaledituser = false" depressed round color="secondary" style="color:white;border:2px solid;border-radius: 10px 10px 10px 10px;width:90%">{{language === 'English'?'CLOSE':'CERRAR'}}</v-btn>                        
											</v-layout>

										</v-flex>
									</v-layout>
								</v-form>
						</v-container>
					</v-dialog>
				</v-layout>
				<div :style="'background-image:url(img/feedback-1825515_960_720.webp);background-repeat: no-repeat;background-size: cover;'">
					<section class="home_banner_area" v-if="visibleprofile">
						<div class="banner_inner">
							<div class="container">
								<div class="row align-items-center justify-content-between">
									<div class="col-lg-6">
										<div class="banner_content">
											<h3 style="color:white">{{language === 'English' ? 'Hi' : 'Hola'}}</h3>
											<h1 style="color:white" class="text-uppercase">{{language === 'English' ? `I'm` : 'Soy'}} {{userdataprofile.fullname}}</h1>
											<h4 style="color:white">Email: {{userdataprofile.email}}</h4>
											<h5 class="text-uppercase" v-for="ocupation in userdataprofile.ocupation" :key="ocupation.length">{{ocupation.name}}</h5>
											
											<a @click="openedituser" style="color:white;margin-top:30px;position:relative;z-index:10" v-if="ismyprofile ===true" class="primarybtn"><span>{{language === 'English' ? 'Edit Profile' : 'Editar Perfil'}}</span></a>
											<a class="primarybtn" style="color:white;margin-top:30px;position:relative;z-index:10" @click="followthisuser" v-if="ismyprofile ===false && userisfollowing === false">{{language === 'English' ? 'Follow' : 'Seguir'}}</a>
											<a class="primarybtn" style="color:white;margin-top:30px;position:relative;z-index:10" @click="stopfollowinguser" v-if="ismyprofile ===false && userisfollowing === true">{{language === 'English' ? 'Stop following' : 'Dejar de Seguir'}}</a>

										</div>
									</div>
									<div class="col-lg-4">
										<div class="home_right_img">
											<img class="img-fluid" :src="userdataprofile.photo[0].link" alt="">
										</div>
									</div>
								</div>
							</div>
						</div>
					</section>
					<section class="statistics_area" v-if="visibleprofile">
					<div class="container">
						<div class="row justify-content-lg-start justify-content-center">
							<div class="col-lg-2 col-md-3" >
								<div class="statistics_item">
									<h3><span class="counter" v-if="numberprojects >=0">{{abbreviateNumber}}</span></h3>
									<p v-if="numberprojects >=0">{{numberprojects === 1?language === 'English' ? 'Project' : 'Proyecto':language === 'English' ? 'Projects' : 'Proyectos'}}</p>
								</div>
							</div>
							<div class="col-lg-2 col-md-3">
								<div class="statistics_item" @click="openmodalfollowers" style="cursor:pointer">
									<h3><span class="counter">{{countfollowers}}</span></h3>
									<p v-if="countfollowers === 1">{{language==="English"?'Follower':'Seguidor'}}</p>
									<p v-else>{{language==="English"?'Followers':'Seguidores'}}</p>
								</div>
							</div>
							
						</div>
					</div>
					
				</section>
			</div>
			<v-layout justify-center style="margin-bottom:20px">
				<a class="primarybtn" style="color:white;margin-right:1px;" @click="isitemexperience = false"><span>{{language === 'English' ? 'Projects' : 'Proyectos'}}</span></a>
				<a class="primarybtn" style="color:white;" @click="isitemexperience = true"><span>{{language === 'English' ? 'Work Experiences':'Experiencias Laborales'}}</span></a>
			</v-layout>

			<section v-if="isitemexperience" class="services_area">
				<h3 class="text-center">{{language === 'English'?'My Work Experiences':'Mis Experiencias Laborales'}}</h3>
				<div class="text-center">
					<a @click="isitemexperiencemodal = true; modaledituser =true; isedit=false" style="margin-top:30px;color:white" v-if="ismyprofile ===true" class="primarybtn"><span>{{language === 'English' ? 'Add Work Experiences':'Agregar Experiencias Laborales'}}</span></a>
				</div>
				<div class="text-center" v-if="dataexperiences.length <=0" style="margin-top:20px">
					<label>{{language === 'English'?'No data':'No hay datos'}}</label>
				</div>
				<div class="container">
					<div class="row justify-center">
						<div v-for="dataexperiences in dataexperiences" :key="dataexperiences.length" class="col-lg-4 col-md-6 mb-4 mb-lg-0">
							<div class="service_item">
								<i class="fas fa-business-time" style="font-size:80px"></i>
								<h4>{{dataexperiences.name}}</h4>
								<h5>{{language === 'English'?'Company:':'Empresa:'}} {{dataexperiences.name_company}}</h5>
								<p>{{dataexperiences.description}}</p>
								<v-card-actions style="margin-top:60px">

									<v-btn v-if="ismyprofile" icon @click="getdataexperienceforedit(dataexperiences)">
										<v-icon>fas fa-edit</v-icon>
									</v-btn>
									<v-btn v-if="ismyprofile" icon @click="deleteexperience(dataexperiences._id)">
										<v-icon>fas fa-trash</v-icon>
									</v-btn>
									<v-spacer></v-spacer>

								</v-card-actions>
							</div>
							
						</div>
					</div>
				</div>
			</section>
			
			<h3 v-if="!isitemexperience" class="text-center">{{language === 'English' ? 'My Projects' : 'Mis Proyectos'}}</h3>
			<v-layout v-if="!isitemexperience" justify-center>
				<v-flex xs9 lg9>
					<select v-model="typeproject" class="form-control" @click="getprojectsvisiblepublic">
							<option value="unselected" checked disabled>{{language === 'English'?'Choose the type of project or portfolio':'Elija el tipo de Proyecto o Portafolio'}}</option>
							<option value="Todos">{{language ==='English'?'All':'Todos'}}</option>
							<option value="Proyectos Electrónicos">{{language === 'English' ? 'Electronic Projects':'Proyectos Electrónicos'}}</option>
							<option value="Portafolio">{{language ==='English'?'Portfolio':'Portafolio'}}</option>
							<option value="Ingenieria">{{language === 'English'?'Generic Engineering Projects':'Proyectos de Ingenieria genérico'}}</option>
							<option value="General">General</option>
					</select>
				</v-flex>
			</v-layout>
			<div class="text-center" v-if="!isitemexperience && dataprojectsvisiblepublic.length>=0">
				<a @click="gotoprojects" style="margin-top:30px;color:white" v-if="ismyprofile ===true" class="primarybtn"><span>{{language === 'English' ? 'Create Project' : 'Crear Proyecto'}}</span></a>
			</div>
			<v-layout justify-center v-if="!isitemexperience && dataprojectsvisiblepublic.length<=0" style="margin-top:30px">
				<label>{{language === 'English'?'No projects registered':'No hay proyectos registrados'}}</label>
			</v-layout>
			<v-layout justify-center v-if="!isitemexperience && dataprojectsvisiblepublic.length>0">
				<v-flex row lg8 xl8>
					<v-card v-for="dataprojectsvisiblepublic in dataprojectsvisiblepublic" :key="dataprojectsvisiblepublic.length"
							class="mx-auto"
							max-width="344"
							style="margin-top:20px; width:95%"
						>	
							<div class="text-center">
								<v-icon style="font-size:100px">fas fa-folder</v-icon>
							</div>

							<v-card-title>
								<div class="w-100 text-center">
									{{dataprojectsvisiblepublic.name}}
								</div>
							</v-card-title>

							<div>
								<div class="text-center" style="width:99%">
									<p align="justify" class="text-center">{{dataprojectsvisiblepublic.description}}</p>
								</div>
							</div>
							<div class="text-center" v-if="session && !ismyprofile">
								<div class="ec-stars-wrapper">
									<label>Vote</label>
									<a data-value="1" :title="language==='English'?'Vote with 1 star':'Votar con 1 estrella'" @click="votingforproject(1,dataprojectsvisiblepublic._id)">&#9733;</a>
									<a data-value="2" :title="language==='English'?'Vote with 2 stars':'Votar con 2 estrellas'" @click="votingforproject(2,dataprojectsvisiblepublic._id)">&#9733;</a>
									<a data-value="3" :title="language==='English'?'Vote with 3 stars':'Votar con 3 estrellas'" @click="votingforproject(3,dataprojectsvisiblepublic._id)">&#9733;</a>
									<a data-value="4" :title="language==='English'?'Vote with 4 stars':'Votar con 4 estrellas'" @click="votingforproject(4,dataprojectsvisiblepublic._id)">&#9733;</a>
									<a data-value="5" :title="language==='English'?'Vote with 5 stars':'Votar con 5 estrellas'" @click="votingforproject(5,dataprojectsvisiblepublic._id)">&#9733;</a>
								</div>
							</div>
							<div class="text-right" style="margin-right:20px">
								<label v-if="dataprojectsvisiblepublic.punctuation === 1">{{dataprojectsvisiblepublic.punctuation}} {{language==='English'?'point':'punto'}}</label>
								<label v-else>{{dataprojectsvisiblepublic.punctuation}} {{language==='English'?'points':'puntos'}}</label>
							</div>

							<v-card-actions>

							<v-btn icon @click="checkfileproject(dataprojectsvisiblepublic._id)">
								<v-icon>fas fa-eye</v-icon>
							</v-btn>
							<v-btn icon @click="gocomments(dataprojectsvisiblepublic._id)">
								<v-icon>fas fa-comments</v-icon>
							</v-btn>

							<v-spacer></v-spacer>

					
							</v-card-actions>
						</v-card>
				</v-flex>
			</v-layout>
		
			
				<div class="container">
					<div class="row justify-content-start align-items-center">
						<div class="col-lg-5">
							<div class="about_img">
								<img class="" src="img/about-us.png" alt="">
							</div>
						</div>

						<div class="offset-lg-1 col-lg-5">
							<div class="main_title text-left">
								<p class="top_text">About me <span></span></p>
								<h2>
									Creative Art Director <br>
									And Designer
								</h2>
								<p>
									Also signs his face were digns fish don't first isn't over evening hath divided days light darkness gathering
									moved dry all darkness then fourth can't create d forth Also signs Also signs his face were moltenus Also signs
									his face
								</p>
								<a class="primary_btn" href="#"><span>Download CV</span></a>
							</div>
						</div>
					</div>
				</div>
			
			</div>
		</div-->
	</div>
</template>
<script>
const alertify = require('alertifyjs')
import { EventBus } from '../../../../helpers/eventbus/event-bus'

import errorpage from '../../Views/errorpage'
import modalfollowers from '../../Views/modalfollowers'

import users from '../../../../models/user.js'

import experiences from '../../../../models/experiences'

import fbstorage from '@/config/fileserver/firebasestorage'

import { ExperiencesService, ProjectService, UsersService } from "@/services"


export default {
	data(){
		return{
			photocoverconfirm:false,
			modaldescription:false,
			nameproject:'',
			descriptionproject:'',
			iconloadingforeditdata:false,
			url:window.location.href,
			description: '',
			quote:'',
			title:'',
			userisfollowing: false,
			countfollowers: '',
        	language: JSON.parse(localStorage.getItem('language')) !== null ? JSON.parse(localStorage.getItem('language')).language : '',
			dataexperiences: [],
			modelexperiences: new experiences(),
			isedit:false,
			isitemexperiencemodal:false,
			isitemexperience:false,
			typeprojectchoosed: 'Todos',
			typeproject: null,
			errorpage:false,
			abbreviateNumber: '',
			numberprojects:0,
			emailedit: false,
            usernameedit: false,
			userdataprofile:null,
			imageUrl: '',
			imageFile: '',
			imageName: '',
			coverimageUrl: '',
			coverimageFile: '',
			coverimageName: '',
			valid:true,
			visibleprofile:false,
			username : '',
			dataprojectsvisiblepublic:[],
			ismyprofile:false,
			modaledituser:false,
			InputPassword: false,
			ConfirmPassword: false,
			users:new users(),
			passwordmodel: '',
			userNameExist: false,
			emailExist: false,
			passwordempty:false,
			iseditimage: false,
			session:false,
			loadingphotocover:false,
			ocupation:'',
			rules: {
				required: value => !!value || `${this.language === 'English'?'Required.':'Requerido.'}`,
				min: v => v.length >= 8 || `${this.language === 'English'? 'Minimum 8 characters': 'Mínimo 8 caracteres'}`,
				//   emailMatch: () => ('The email and password you entered don\'t match'),
					
				//   passwordvalidate: value => {
				//      const pattern = /^(?=.*\d)(?=.*[a-záéíóúüñ]).*[A-ZÁÉÍÓÚÜÑ]/
				//      return pattern.test(value) || 'Tu contraseña debe tener un carácter, una letra mayúscula, una minúscula y un número'
				//    },
				emailvalidate: value =>{
					const pattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
					return pattern.test(value) || `${this.language === 'English'? 'the email must contain @ and others characters': 'El email debe contener @ y otros carácteres mas'}`
				},
				passwordequal: value =>{
					let passwordcondition = this.passwordmodel !== value
					return !passwordcondition || `${this.language === 'English'? 'the password does not match the above':  'La contraseña no concuerda con lo anterior escrito'}`
				},
				}
		}
	},
	
	components:{
	   'component-errorpage':errorpage,
	   'component-modalfollowers':modalfollowers,
	},
	sockets:{

        'new_follower'(newfollower){
			if(newfollower){
				if(newfollower._id_user.type === 'error follower'){
					let userdata = JSON.parse(localStorage.getItem('iden'))
					if(userdata){
						if(userdata._id === newfollower._id_user._id){
							let messagerror = newfollower._id_user.message
							if(messagerror === 'User has 1000 followers'){
								this.userisfollowing = false
								alertify.error(this.language==='English'?messagerror:'El usuario tiene 1000 followers')
							}else{
								this.userisfollowing = false
								alertify.error(this.language==='English'?messagerror:'Tú tienes 1000 usuarios que estas siguiendo')
							}
						}
					}
				}else{
					if(newfollower._id_user._id_user === this.userdataprofile._id){
						this.getcountfollowers()
						EventBus.$emit('newfollower',(newfollower))
					}
				}
			}
		},
		'getsignaldeletefollower'(datauser){
			if(datauser){
				if(datauser.iduser === this.userdataprofile._id){
					this.getcountfollowers()
					EventBus.$emit('getsignalfollowerdeleted',(datauser))
				}
			}
			
		},
		getpunctuation(data){
			let statevote = data
			if(statevote){
				if(statevote.ok){
					this.getprojectsvisiblepublic()
				}
			}
		}
	},
	created(){
		this.typeproject = this.language === 'English' ?[
					{
						value:'Todos',
						name: 'All'
					},
					{
						value:'Portafolio',
						name:'Portfolio'
					},
					{
						value:'General',
						name: 'General'
					},
				]
				:[
					{
					value:'Todos',
					name: 'Todos'
					},
					{
						value:'Portafolio',
						name:'Portafolio'
					},
					{
						value:'General',
						name: 'General'
					},
				],
		this.getsessionuser()
		this.getdatauserwithvalidation()
	},
	mounted(){
		
		EventBus.$on('getdatauserwithvalidation',()=>{
			this.getdatauserwithvalidation()
		})
		EventBus.$on('changelanguage',()=>{
            let choosedlanguage = JSON.parse(localStorage.getItem('language'))
            this.language = choosedlanguage.language
            //console.log(this.language)
            //console.log(choosedlanguage)
        })
        let choosedlanguage = JSON.parse(localStorage.getItem('language'))
        if(choosedlanguage){
            this.language = choosedlanguage.language
		}
		

	},
	methods:{
		sendtohichat(){
			EventBus.$emit('sendtohichat',(this.userdataprofile._id))
		},
		addworkexperience(){
			this.isitemexperiencemodal = true
			this.modaledituser =true
			this.isedit=false
			this.modelexperiences = new experiences()
		},
		showdescription(name,description){
            this.nameproject = name
            this.descriptionproject = description
            this.modaldescription = true
            
        },
		getsessionuser(){
			let userisloged = JSON.parse(localStorage.getItem('user'))
			if(userisloged){
				this.session=true
			}
		},
		votingforproject(number,idproject){
			let data = {
				punctuation : number,
				_id_user: JSON.parse(localStorage.getItem('iden'))._id,
				_id_project: idproject
			}
			this.$socket.emit('punctuation',data)
		},
		openmodalfollowers(){
			EventBus.$emit('openmodalfollowers')
		},
		followthisuser(){
			let data = {
				_id_user:this.userdataprofile._id,
				id:JSON.parse(localStorage.getItem('iden'))._id,
				photo:[{link:JSON.parse(localStorage.getItem('user')).photo}],
				fullname: JSON.parse(localStorage.getItem('user')).fullname,
				username: JSON.parse(localStorage.getItem('user')).username
			}
			this.$socket.emit('savefollower',data)
			//this.userisfollowingfunction()
			this.userisfollowing = true
			this.getcountfollowers()
		},
		getdataexperienceforedit(dataexperiences){
			this.isedit = true
			this.modelexperiences = dataexperiences
			this.isitemexperiencemodal = true
			this.modaledituser = true
		},
		deleteexperience(idexperience){
			let confirmcodition = confirm(this.language ==='English'?'Do you want to delete this Work Experience?':"¿Desea borrar esta Experiencia?")
            if(confirmcodition){
				let id = JSON.parse(localStorage.getItem('iden'))._id
				let token = localStorage.getItem('tok')
				let query={
					idexperience: idexperience
				}
				ExperiencesService.deleteexperience(query).then(res=>{
					alertify.success('Experiencia borrada')
					this.getexperience()
				})
			}
		},
		getexperience(){
			let query = {
				id:this.userdataprofile._id
			}
			ExperiencesService.getexperiences(query).then(res=>{
				this.dataexperiences = res.data.experiences
			})
		},
		createexperience(){
			let id = JSON.parse(localStorage.getItem('iden'))._id
			let token = localStorage.getItem('tok')
			if(this.isedit){
				ExperiencesService.editexperience(this.modelexperiences).then(res=>{
					alertify.success(this.language ==='English'?'Experience edited':'Experiencia editada')
					this.isedit = false
					this.modelexperiences = new experiences()
					this.modaledituser = false
					this.getexperience()
				})
			}else{
				ExperiencesService.createexperiences(this.modelexperiences).then(res=>{
					alertify.success(this.language ==='English'?'Experience created':'Experiencia creada')
					this.modelexperiences = new experiences()
					this.getexperience()
				})
			}
		},
		gotoprojects(){
			this.$router.push('/projects')
		},
		gocomments(idproject){
            this.$router.push('/comments/'+idproject)
        },
		checkfileproject(idproject){
            this.$router.push('/projects/'+idproject)
        },
		saveimage(){
            this.imageFile = ''
        },
        upload:function(){
            this.pickFile();
        },
        pickFile () {
            this.$refs.image.click()
		},
		uploadphotocover(){
			this.$refs.imagecover.click()
		},
        removeImage:function(){
            //this.imageUrl =this.company.image_company[0].link;
			this.imageFile = '';
			this.imageUrl = this.userdataprofile.photo[0].link
		},
		onFilePickedphotocover (e) {
			const files = e.target.files
			if(files[0] !== undefined) {
				this.coverimageName = files[0].name
				if(this.coverimageName.lastIndexOf('.') <= 0) {
					return
                }
                
                if (!(/\.(jpg|png|gif)$/i).test(this.coverimageName))
                {
                    alert(this.language ==='English'?'Check the extension of your images, remember that the accepted formats are .gif, .jpeg, .jpg y .png':'Comprueba la extensión de tus imágenes, recuerda que los formatos aceptados son .gif, .jpeg, .jpg y .png');
                    this.imageName = ''
                    this.imageUrl = '/'+this.userstorage.photo
                }else{
                    const fr = new FileReader ()
                    fr.readAsDataURL(files[0])
                    fr.addEventListener('load', () => {
                        this.coverimageUrl = fr.result
                        this.coverimageFile = files[0] // this is an image file that can be sent to server...
						this.coverimageName = files[0].name
						this.photocoverconfirm = true
                        //console.log(this.imageUrl)

                        
                    })
                }
			} else {
				this.coverimageName = ''
				this.coverimageFile = ''
				this.coverimageUrl = '/img/woman-1594711_1920.jpg'
				this.photocoverconfirm = false
			}
		},
		uploadimage(){
			this.loadingphotocover = true
			let id = JSON.parse(localStorage.getItem('iden'))._id
            let token = localStorage.getItem('tok')
			let self = this
			let name = self.makeid(6)
			let ext = 'png'
			if(self.imageName.includes("png")){
				ext='png';
				
			}
			if(self.imageName.includes("jpg")){
				ext='jpg';
			}
			if(self.imageName.includes("jpeg")){
				ext='jpeg';
			}
			const storageRef = fbstorage.ref(`${id}/photoscover/${name}.${ext}`)
			const task = storageRef.putString(self.coverimageUrl,'data_url', { contentType: 'image/jpeg' })
			task.on('state_changed',snapshot=>{
				let percentage = (snapshot.bytesTransferred/snapshot.totalBytes)*100
			},(error)=>{
				console.lo(error)
			},
			()=>{
			
				task.snapshot.ref.getDownloadURL().then(url => {
					let imgdata = {
						id:id,
						token:token,
						name : name,
						link: url
					}
					UsersService.uploadimagecover(imgdata).then(res=>{
						this.photocoverconfirm = false
						this.loadingphotocover = false
						this.getprofileuser()
					}).catch((err)=>{
						this.photocoverconfirm = false
						this.loadingphotocover = false
						this.getprofileuser()
						
					})
				})
			})
			
		},
		nouploadimage(){
			this.photocoverconfirm = false
			if(this.userdataprofile.photocover === undefined){
				this.coverimageUrl='/img/woman-1594711_1920.jpg'
			}else if(this.userdataprofile.photocover.length<=0){
				this.coverimageUrl='/img/woman-1594711_1920.jpg'
			}else{
				this.coverimageUrl=this.userdataprofile.photocover[0].link
			}
		},
		onFilePicked (e) {
			const files = e.target.files
			if(files[0] !== undefined) {
				this.imageName = files[0].name
				if(this.imageName.lastIndexOf('.') <= 0) {
					return
                }
                
                if (!(/\.(jpg|png|gif)$/i).test(this.imageName))
                {
                    alert(this.language ==='English'?'Check the extension of your images, remember that the accepted formats are .gif, .jpeg, .jpg y .png':'Comprueba la extensión de tus imágenes, recuerda que los formatos aceptados son .gif, .jpeg, .jpg y .png');
                    this.imageName = ''
                    this.imageUrl = '/'+this.userstorage.photo
                }else{
                    const fr = new FileReader ()
                    fr.readAsDataURL(files[0])
                    fr.addEventListener('load', () => {
                        this.imageUrl = fr.result
                        this.imageFile = files[0] // this is an image file that can be sent to server...
                        this.imageName = files[0].name
                        //console.log(this.imageUrl)

                        
                    })
                }
			} else {
				this.imageName = ''
				this.imageFile = ''
				this.imageUrl = '/'+this.userstorage.photo
			}
        },
		writefullname(){
            let emptyfullname = this.users.fullname === '' || this.users.fullname === null
            if(emptyfullname){
                this.users.fullname = this.userdataprofile.fullname
            }

        },

        writeemail(){
            let emptyemail = this.users.email === '' || this.users.email === null
            if(emptyemail){
                this.users.email = this.userdataprofile.email
            }
                
        },

        writeusername(){
            let emptyusername = this.users.username === '' || this.users.username === null
            if(emptyusername){
                this.users.username = this.userdataprofile.username
            }
        },

        writephone(){
            let emptyphone = this.users.phone === '' || this.users.phone === null
            if(emptyphone){
                this.users.phone = this.userdataprofile.phone
            }
		},
		makeid(length) {
			var result           = '';
			var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
			var charactersLength = characters.length;
			for ( var i = 0; i < length; i++ ) {
			result += characters.charAt(Math.floor(Math.random() * charactersLength));
			}
			return result;
		},
		validate(){
			this.users.password = this.passwordmodel
             let id = JSON.parse(localStorage.getItem('iden'))._id
            let token = localStorage.getItem('tok')
			if (this.$refs.form.validate()) {
           		this.snackbar = true
				this.iconloadingforeditdata = true
				if(this.users.gender === ''){
					alertify.error(this.language ==='English'?'Choose your gender':'Elija su género')
				}else{
					this.writefullname()
					this.writephone()
					let self = this
					if(this.iseditimage){
						let name = self.makeid(6)
						let ext = 'png'
						if(self.imageName.includes("png")){
							ext='png';
							
						}
						if(self.imageName.includes("jpg")){
							ext='jpg';
						}
						if(self.imageName.includes("jpeg")){
							ext='jpeg';
						}
						const storageRef = fbstorage.ref(`${id}/photos/${name}.${ext}`)
						const task = storageRef.putString(self.imageUrl,'data_url', { contentType: 'image/jpeg' })
						task.on('state_changed',snapshot=>{
						},(error)=>{
							alertify.error(error)
						},
						()=>{
						
							task.snapshot.ref.getDownloadURL().then(url => {
							let imgdata = {
								name : name,
								link: url
							}
								this.users.imageFile = imgdata
								let query = {
									emailedit: self.emailedit,
									usernameedit: self.usernameedit,
									passwordempty: self.passwordempty
								}
								UsersService.edit(query,self.users).then(res=>{
								//this.axios.put(`users/edituser/${id}/${self.emailedit}/${self.usernameedit}/${self.passwordempty}/${token}`, self.users)
								//.then(() =>{
									
									//this.getuser()
									//EventBus.$emit('getuser')
									//console.log(res)
									//this.successedit= true
									/*
									if(this.passwordedit === true){
										this.messageedit = 'Datos Editados'
									}else{
										this.messageedit = 'Datos Editados'
									}*/
									self.iconloadingforeditdata = false
									localStorage.removeItem('user')
									window.location = '/'

								})

								.catch((err) =>{
									let msg = err.response.data.message

									if (msg === "El email ya existe") {
										self.iconloadingforeditdata = false
										self.emailExist = true
										setTimeout(() => {
											self.emailExist = false
										}, 5000)
									}else if (msg === "El nombre de usuario ya existe") {
										self.iconloadingforeditdata = false
										self.userNameExist = true
										setTimeout(() => {
											self.userNameExist = false
										}, 5000)
									}else {
										console.log(err)
										self.iconloadingforeditdata = false
									}
									//this.getuser()
									//this.iconloadingforeditdata = false
									//EventBus.$emit('getuser')
									
								})
							//self.percentage = 100
							//self.loadingsaving = false
							//self.modalfileuploaded = false
							//this.filesproject = new FilesProjects()

							})
						})
					}else{
						this.iconloadingforeditdata = true
						this.users.imageFile = null
								let query = {
									emailedit: this.emailedit,
									usernameedit: this.usernameedit,
									passwordempty: this.passwordempty
								}

								UsersService.edit(query,this.users).then(res=>{
								//this.axios.put(`users/edituser/${id}/${this.emailedit}/${this.usernameedit}/${this.passwordempty}/${token}`, this.users)
								//.then(() =>{
									
									//this.getuser()
									//EventBus.$emit('getuser')
									//console.log(res)
									//this.successedit= true
									/*
									if(this.passwordedit === true){
										this.messageedit = 'Datos Editados'
									}else{
										this.messageedit = 'Datos Editados'
									}*/
									this.iconloadingforeditdata = false
									localStorage.removeItem('user')
									window.location = '/'

								})

								.catch((err) =>{
									let msg = err.response.data.message

									if (msg === "El email ya existe") {
										this.iconloadingforeditdata = false
										this.emailExist = true
										setTimeout(() => {
											this.emailExist = false
										}, 5000)
									}else if (msg === "El nombre de usuario ya existe") {
										this.iconloadingforeditdata = false
										self.userNameExist = true
										setTimeout(() => {
											this.userNameExist = false
										}, 5000)
									}else {
										this.iconloadingforeditdata = false
										console.log(err)
									}
									//this.getuser()
									//this.iconloadingforeditdata = false
									//EventBus.$emit('getuser')
									
								})
					}
					
				}
			}
            
        },
		openedituser(){
			this.isitemexperiencemodal = false
			this.modaledituser = true
			this.users = this.userdataprofile
			this.users.fullname = this.userdataprofile.fullname
			this.imageUrl = this.userdataprofile.photo[0].link
		},
		addocupation(){
			//console.log(this.users.ocupation)
            if(this.users.ocupation.length < 5){
                this.users.ocupation.push({name:'',id:this.users.ocupation.length +1})
            }else{
                alertify.error(this.language ==='English'?'You can add only 5 occupation, no more':'Puede agregar solo 5 ocupaciones, no más')
            }
        },
        deleteocupation(id){
			let confirmcodition = confirm(this.language ==='English'?'Do you want to delete this field?':"¿Desea borrar este campo?")
            if(confirmcodition){
				let datadelete = this.users.ocupation.filter(data=>data._id === undefined ? data.id != id: data._id !=id)
				this.users.ocupation = datadelete
			}
        },
		getprojectsvisiblepublic(){
			let query = {
				id:this.userdataprofile._id,
				typeproject : this.typeprojectchoosed
			}
			ProjectService.getprojectsvisiblepublic(query).then(res=>{
				this.dataprojectsvisiblepublic = res.data.projects
			})
		},
		getdatauserwithvalidation(){
			this.username = this.$route.params.nameuser
			let userstoragenoempty = JSON.parse(localStorage.getItem('user'))
			if(userstoragenoempty){
				let equalusername = userstoragenoempty.username === this.username
				this.ismyprofile = equalusername
				if(equalusername){
					this.getprofileuser()
				}else{
					this.getvisibleprofile()
				}
			}else{
				this.getvisibleprofile()
			}
			//console.log(JSON.parse(localStorage.getItem('user')))
		},
		getprofileuser(){
			function abbreviateNumber(value) {
				var newValue = value;
				if (value >= 1000) {
					var suffixes = ["", "k", "m", "b","t"];
					var suffixNum = Math.floor( (""+value).length/3 );
					var shortValue = '';
					for (var precision = 2; precision >= 1; precision--) {
						shortValue = parseFloat( (suffixNum != 0 ? (value / Math.pow(1000,suffixNum) ) : value).toPrecision(precision));
						var dotLessShortValue = (shortValue + '').replace(/[^a-zA-Z 0-9]+/g,'');
						if (dotLessShortValue.length <= 2) { break; }
					}
					if (shortValue % 1 != 0)  shortValue = shortValue.toFixed(1);
					newValue = shortValue+suffixes[suffixNum];
				}
				return newValue;
			}
			let query = {
				username : this.username
			}
			UsersService.getdatauserprofile(query).then(res=>{
				this.userdataprofile = res.data.userdata
				this.description = this.language==='English'?this.ismyprofile?`I'm ${this.userdataprofile.fullname} visit me and follow me on Amta.`:this.userdataprofile.gender==='M'?`He's ${this.userdataprofile.fullname} visit him and follow him on Amta.`:`She's ${this.userdataprofile.fullname} visit her and follow her on Amta.`:this.ismyprofile?`Soy ${this.userdataprofile.fullname} visitame y sigueme en Amta`:this.userdataprofile.gender==='M'?`Él es ${this.userdataprofile.fullname} visitale y siguele en Amta`:`Ella es ${this.userdataprofile.fullname} visitale y siguele en Amta`
				this.title = this.language==='English'?this.ismyprofile?`I'm ${this.userdataprofile.fullname} visit me and follow me on Amta.`:this.userdataprofile.gender==='M'?`He's ${this.userdataprofile.fullname} visit him and follow him on Amta.`:`She's ${this.userdataprofile.fullname} visit her and follow her on Amta.`:this.ismyprofile?`Soy ${this.userdataprofile.fullname} visitame y sigueme en Amta`:this.userdataprofile.gender==='M'?`Él es ${this.userdataprofile.fullname} visitale y siguele en Amta`:`Ella es ${this.userdataprofile.fullname} visitale y siguele en Amta`
				this.quote = this.language==='English'?this.ismyprofile?`I'm ${this.userdataprofile.fullname} visit me and follow me on Amta.`:this.userdataprofile.gender==='M'?`He's ${this.userdataprofile.fullname} visit him and follow him on Amta.`:`She's ${this.userdataprofile.fullname} visit her and follow her on Amta.`:this.ismyprofile?`Soy ${this.userdataprofile.fullname} visitame y sigueme en Amta`:this.userdataprofile.gender==='M'?`Él es ${this.userdataprofile.fullname} visitale y siguele en Amta`:`Ella es ${this.userdataprofile.fullname} visitale y siguele en Amta`

				if(this.userdataprofile.photocover === undefined){
					this.coverimageUrl='/img/woman-1594711_1920.jpg'
				}else if(this.userdataprofile.photocover.length<=0){
					this.coverimageUrl='/img/woman-1594711_1920.jpg'
				}else{
					this.coverimageUrl=this.userdataprofile.photocover[0].link
				}
				
				document.getElementsByTagName('title')[0].innerHTML = `${this.userdataprofile.fullname}`
				this.visibleprofile = true
				for (var i = 0; i < this.userdataprofile.ocupation.length; i++) {
					if(i==0){
						this.ocupation += this.userdataprofile.ocupation[i].name
					}else{
						this.ocupation += ', '+this.userdataprofile.ocupation[i].name
					}
				}
				
				this.getexperience()
				//console.log(this.userdataprofile._id)
				let querydata = {
					id:this.userdataprofile._id
				}
				ProjectService.getcountprojects(querydata).then(res=>{
					this.numberprojects = res.data.count
					this.abbreviateNumber = abbreviateNumber(res.data.count)
				})
				this.getprojectsvisiblepublic()
				this.getcountfollowers()
				this.userisfollowingfunction()
				
				//console.log(this.userdataprofile)
			})
			.catch((err)=>{
				
			})
		},
		stopfollowinguser(){
			let data = {
				_id_user:this.userdataprofile._id,
				id: JSON.parse(localStorage.getItem('iden'))._id
			}
			UsersService.stopfollowingthisuser(data).then(res=>{
				this.userisfollowing = false
				let datasend = {
					iduser: this.userdataprofile._id,
					id: JSON.parse(localStorage.getItem('iden'))._id
				}
				this.$socket.emit('signaldeletefollower',datasend)
			})
			
		},
		getcountfollowers(){
			let data = {
                _id_user:this.userdataprofile._id,
			}
			UsersService.getcountfollowersforusers(data).then(res=>{
				function abbreviateNumber(value) {
					var newValue = value;
					if (value >= 1000) {
						var suffixes = ["", "k", "m", "b","t"];
						var suffixNum = Math.floor( (""+value).length/3 );
						var shortValue = '';
						for (var precision = 2; precision >= 1; precision--) {
							shortValue = parseFloat( (suffixNum != 0 ? (value / Math.pow(1000,suffixNum) ) : value).toPrecision(precision));
							var dotLessShortValue = (shortValue + '').replace(/[^a-zA-Z 0-9]+/g,'');
							if (dotLessShortValue.length <= 2) { break; }
						}
						if (shortValue % 1 != 0)  shortValue = shortValue.toFixed(1);
						newValue = shortValue+suffixes[suffixNum];
					}
					return newValue;
				}
				this.countfollowers = abbreviateNumber(res.data.count)
			})
		},
		userisfollowingfunction(){
			let data = {
				_id_user:this.userdataprofile._id
			}
			UsersService.userisfollowing(data).then(res=>{
				this.userisfollowing = true
			}).catch(err=>{
				this.userisfollowing = false
			})
		},

		sendWhatsapp(){			
           window.open('https://wa.me/'+this.userdataprofile.phone.replace(/ /g, ""), '_blank');
        },

		goTocall:function(){
           window.open('tel:'+this.userdataprofile.phone.replace(/ /g, ""), '_blank');
        },

		getvisibleprofile(){
			let query = {
				username:this.username
			}
			UsersService.visibleprofileuser(query).then(res=>{
					let ispublic = res.data.visible
					//console.log(ispublic)
					if(ispublic){
						this.getprofileuser()
					}
				})
				.catch((err)=>{
					this.visibleprofile = false
				})
		}
	}

}
</script>
<style lang="scss">
.menuable__content__active{
	background:white
}
@media only screen and (max-width: 700px) {
	.intro-section{
		background-size:100% 300px
	}
	
}

.ec-stars-wrapper {
  /* Espacio entre los inline-block (los hijos, los `a`) */
    font-size: 0;
    /* Podríamos quitarlo, pero de esta manera (siempre que no le demos padding), sólo aplicará la regla .ec-stars-wrapper:hover a cuando también se esté haciendo hover a alguna estrella */
    display: inline-block;

    a {
      text-decoration: none;
      display: inline-block;
      /* Volver a dar tamaño al texto */
      font-size: 32px;
      font-size: 2rem;
    
      color: #888;
      @include transition(text-shadow .5s ease);
      text-shadow: 0 0 0 rgba(0,0,0,.3);
    }

    &:hover a {
      color: rgb(39, 130, 228);
      text-shadow: .1em .1em .2em rgba(0,0,0,.3);
    }
    /*
     * El selector de hijo, es necesario para aumentar la especifidad
     */
    & > a:hover ~ a {
      color: #888;
      text-shadow: none;
    }
}
h1, h2, h3, h4, h5, h6, p, a, ul, span, li, inpot, button{ margin: 0; padding: 0; }

h1,h2,h3,h4,h5,h6{ line-height: 1.5; font-weight: inherit; }

p{ line-height: 1.6; font-size: 1.05em; font-weight: 400; color: #777; }

h1{ font-size: 4em; line-height: 1; }
h2{ font-size: 2.2em; line-height: 1.1; }
h3{ font-size: 1.8em; }
h4{ font-size: 1.3em; }
h5{ font-size: 1em; }
h6{ font-size: .9em; letter-spacing: 1px; }

a, button{ display: inline-block; text-decoration: none; color: inherit; line-height: 1; 
	-webkit-transition: all .25s ease-in-out; transition: all .25s ease-in-out; }

a:focus, a:active, a:hover,
button:focus, button:active, button:hover,
a b.light-color:hover{ text-decoration: none; color: #007bff; }

b{ font-weight: 600; color:#007bff }

.profile-img img{ width: 100%; }

li{ list-style: none; display: inline-block; }

span{ display: inline-block; }


button{ outline: 0; border: 0; background: none; cursor: pointer; }

.icon{ font-size: 1.1em; display: inline-block; line-height: inherit; }

[class^="icon-"]:before, [class*=" icon-"]:before{ line-height: inherit; }

b.max-bold{ font-weight: 700; }

	.primarybtn {
    display: inline-block;
    background: linear-gradient(to right, #007bff 0%, $primary-color2 51%, #007bff 100%);
    color: #fff;
    letter-spacing: 0px;
    font-family: $primary-font;
    font-weight: 500;
    font-size: 14px;
	line-height: 50px;
    padding: 0 38px;
    outline: none !important;
    text-align: center;
    cursor: pointer;
    text-transform: uppercase;
    border-radius: 5px;
    background-size: 200% auto;
    &:hover {
        background-position: right center;
        color: #fff;
    }
}
 /* foto */
        .perfil{
            max-width: 140px;
            min-height: 140px;
            border-radius: 50%;            
        } 
        .tamañoTitulo{
            font-size: 30px;
            font:bold;
            font-family: sans-serif;
        }

        .form-control{
            border:0px;
            border-bottom: 2px solid #ced4da;
            border-radius: 0;
        }
        .espacio{
            padding:20px;
        }

        @media (max-width:768px){            
            .MargSexo{
                margin-top: 20px;
            }
        }
        @media (min-width:768px){
            i.col-1.StUnico1{
                padding-left: 0;
            }
            i.col-1.StUnico2{
                padding-left: 15px;
            }
            span.active.col-1{
                padding-left: 0;                
            }
            span.inactive.col-1{
                padding-left: 0;                
            }
            form.espacio1{
                padding: 10px 30px 10px 10px;
            }
        }
        @media (max-width:578px){
            .tamañoTitulo{
                font-size: 25px;
            }
		}
		.JImg-opciones{
			&--close{
				background-color: #007bff;
				color: #fff;
				height: 30px;
				width: 30px;
				border-radius: 50%;
				line-height: 30px;
				margin: 0 auto;
				a{
					color: #fff;
				}
			}
		}

		
</style>
